import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "title"
};
const _hoisted_4 = {
    key: 1,
    class: "sub-title"
};
const _hoisted_5 = { class: "value-title" };
const _hoisted_6 = { class: "value mt-1" };
const _hoisted_7 = ["href"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 0,
    class: "comingSoon"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'InfoPanel',
    props: {
        icon: {},
        title: {},
        subtitle: {},
        valueTitle: {},
        value: {},
        blur: { type: Boolean },
        href: {},
        valueHref: {},
        flex: { type: Boolean },
        showArrow: { type: Boolean },
        chevron: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('info-panel'),
                style: _normalizeStyle(_ctx.flex ? 'height: 100%' : '')
            }, [
                _createElementVNode("a", { href: _ctx.href }, [
                    _createElementVNode("div", {
                        class: _normalizeClass((_ctx.blur ? 'blur' : ''))
                    }, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                (_ctx.icon && _ctx.icon != '')
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: "icon-col v-col-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("img", { src: _ctx.icon }, null, 8, _hoisted_2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_col, {
                                    class: _normalizeClass(["title-col", { 'no-subtitle': !_ctx.subtitle && !_ctx.$slots.subtitle }])
                                }, {
                                    default: _withCtx(() => [
                                        (_ctx.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
                                            : _createCommentVNode("", true),
                                        (_ctx.subtitle || _ctx.$slots.subtitle)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                                                    _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 3
                                }, 8, ["class"]),
                                (_ctx.valueTitle && _ctx.value)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        class: "right-col v-col-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.valueTitle), 1),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("a", { href: _ctx.valueHref }, _toDisplayString(_ctx.value), 9, _hoisted_7)
                                            ])
                                        ]),
                                        _: 1
                                    }))
                                    : (_ctx.showArrow || _ctx.chevron)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 2,
                                            class: "arrow-col v-col-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                    src: require('@/assets/arrow-right.png'),
                                                    class: _normalizeClass(["arrow", _ctx.chevron])
                                                }, null, 10, _hoisted_8)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 3
                        })
                    ], 2)
                ], 8, _hoisted_1),
                _renderSlot(_ctx.$slots, "default"),
                (_ctx.blur)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Coming Soon"))
                    : _createCommentVNode("", true)
            ], 4));
        };
    }
});
